import { render } from "./FeedBacks.vue?vue&type=template&id=804013ce&scoped=true"
import script from "./FeedBacks.vue?vue&type=script&lang=js"
export * from "./FeedBacks.vue?vue&type=script&lang=js"

import "./FeedBacks.vue?vue&type=style&index=0&id=804013ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-804013ce"]])

export default __exports__